import { createContext, useContext } from "react";
import { createPortal } from "react-dom";

/** DOM-узел справа от переключателя разделов «Учет и планирование» */
export const AccountingPlanningActionsContext = createContext(null);

/** Выводит кнопки страницы в общую строку навигации раздела */
function AccountingPlanningActions({ children }) {
  const container = useContext(AccountingPlanningActionsContext);
  return container ? createPortal(children, container) : null;
}

export default AccountingPlanningActions;
